import { BundleResourcesPackage } from "resource-system";
import { Texture } from "@pixi/core";
export class CommonUIResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("CommonUIResourcesPackage");
    }
    public get assets_common_button_yellow_png(): Texture {
        return this.resource<Texture>("assets/common/button_yellow.png");
    }
    public get assets_common_close_button_png(): Texture {
        return this.resource<Texture>("assets/common/close_button.png");
    }
    public get assets_common_root_png(): Texture {
        return this.resource<Texture>("assets/common/root.png");
    }
}

